import { AppContent } from '@/components/app-content';
import { AppHeader } from '@/components/app-header';
import { AppShell } from '@/components/app-shell';
import { HelpCrunchProvider } from '@/contexts/HelpCrunchContext';
import { type BreadcrumbItem } from '@/types';
import type { PropsWithChildren } from 'react';

export default function AppHeaderLayout({
    children,
    breadcrumbs,
}: PropsWithChildren<{ breadcrumbs?: BreadcrumbItem[] }>) {
    return (
        <AppShell>
            <HelpCrunchProvider
                organization={import.meta.env.VITE_HELPCRUNCH_API_ORGANIZATION}
                appId={import.meta.env.VITE_HELPCRUNCH_APP_ID}
            >
                <AppHeader breadcrumbs={breadcrumbs} />
                <AppContent>{children}</AppContent>
            </HelpCrunchProvider>
        </AppShell>
    );
}
